<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="overview-wrap">
          <h2 class="title-1">Зарын баннер</h2>
        </div>
      </div>
    </div>

    <div class="row my-3">
      <div class="card w-100">
        <div v-if="!isContentMgr" class="card-header d-flex justify-content-end">
          <router-link :to="{name: 'BannerCreate'}">
            <button class="btn btn-primary">
              <i class="fas fa-plus"></i>
            </button>
          </router-link>
        </div>
        <div v-if="banners != null" class="card-body row">
          <table class="table">
            <tbody>
              <tr v-for="(banner, i) in this.banners" :key="i">
                <td class="banner-container" width="200" height="120">
                  <img class="mh-100 mw-100" v-bind:src="banner.pcImage">
                </td>
                <td>
                  <h5>{{banner.name}}</h5>
                  <p>{{banner.startDate}} — {{banner.endDate}}</p>
                  <a style="max-width: 500px;"
                    v-if="banner.url != null && banner.url != ''"
                    v-bind:href="banner.url"
                  >{{banner.url}}</a>
                </td>
                <td v-if="!isContentMgr" class="text-right" style="min-width: 104px;">
                  <router-link :to="{name : 'BannerEdit', params: {id: banner.id}}" class="mx-2">
                    <button class="btn btn-info btn-sm">
                      <i class="fas fa-edit"></i>
                    </button>
                  </router-link>
                  <button @click="deleteBanner(banner.id)" class="btn btn-danger btn-sm">
                    <i class="fas fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <v-dialog/>
  </div>
</template>

<script>
import BannerService from "@/services/BannerService";
import DeleteDialog from "@/mixins/DeleteDialog.js";

export default {
  name: "Banner",

  mixins: [DeleteDialog],

  created() {
    this.$store.dispatch("setLoading", true);
    this.getBanners();
  },

  computed: {
    isContentMgr: function() {
      return this.$store.getters.loggedAdmin.role == 2;
    }
  },

  data() {
    return {
      banners: null
    };
  },

  methods: {
    getBanners() {
      BannerService.getBannersList({}).then(response => {
        if (response.status == 200 && response.data.success == true)
          this.banners = response.data.payload;

        this.$store.dispatch("setLoading", false);
      });
    },

    deletedHandler(id) {
      let index = this.banners.map(banner => banner.id).indexOf(id);
      if (index > -1) this.banners.splice(index, 1);
    },

    deleteBanner(id) {
      this.confirmDelete(
        id,
        "Баннер устгах!",
        "Та энэ баннерийг устгах уу?",
        BannerService.deleteBanner,
        this.deletedHandler
      );
    }
  }
};
</script>